'use strict';

const EventPipe = require('../../deal/frontend/event_pipe');

const addBuyButtonClickHandler = function addBuyButtonClickHandler(fn) {
  const $buyButtons = document.querySelectorAll('.buy-button .buy');
  $buyButtons.forEach($buyButton => {
    $buyButton.addEventListener('click', event => {
      this.eventPipe.trigger('buy_button_clicked', event);
    });

    if (fn) {
      this.eventPipe.on('buy_button_clicked', fn);
    }
  });
};

const addOptionsClickHandler = function addOptionsClickHandler(fn) {
  const $inlineList = document.querySelector(
    '.multi-option-breakout.inline-list'
  );
  if ($inlineList) {
    $inlineList.addEventListener('click', event => {
      if (event.target.nodeName.toLowerCase() === 'input') {
        this.eventPipe.trigger('option_clicked', {
          $option: event.target,
          isInline: true,
        });
      }
    });

    if (fn) {
      this.eventPipe.on('option_clicked', fn);
    }
  }
};

const addEventPipe = function addEventPipe() {
  this.eventPipe = new EventPipe();
  window.BuyButtonEventPipe = this.eventPipe;
};

module.exports = {
  addEventPipe,
  addBuyButtonClickHandler,
  addOptionsClickHandler,
};
